import { render, staticRenderFns } from "./importData.vue?vue&type=template&id=4380b5e1&scoped=true"
import script from "./importData.vue?vue&type=script&lang=js"
export * from "./importData.vue?vue&type=script&lang=js"
import style0 from "./importData.vue?vue&type=style&index=0&id=4380b5e1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4380b5e1",
  null
  
)

export default component.exports